<template>
  <div class="ticket-group">
    <el-form :model="rowData" :rules="rules" ref="form" label-width="0">
      <ul class="ticket-body">
        <li class="ticket-td">
          <el-form-item prop="name">
            <el-input v-model="rowData.name" placeholder="请输入票品名称"></el-input>
          </el-form-item>
        </li>
        <li class="ticket-td">
          <el-form-item prop="typeId">
            <el-select v-model="rowData.typeId" placeholder="请选择类型" style="width:100%;" :disabled="disabledInput" @change="changeType">
              <el-option v-for="item of ticketTypeList" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </li>
        <li class="ticket-td">
          <el-form-item prop="price">
            <el-input v-model="rowData.price" placeholder="请输入票价"></el-input>
          </el-form-item>
        </li>
        <li class="ticket-td">
          <el-form-item prop="count">
            <el-input v-model="rowData.count" placeholder="请输入库存"></el-input>
          </el-form-item>
        </li>
        <li class="ticket-td">
          <span v-if="rowData.status == 0" style="color:#F56C6C;">上架中</span>
          <span v-if="rowData.status == 1">已下架</span>
        </li>
        <li class="ticket-td setting">
          <span v-if="rowData.status == 0" @click="upDownTicket(1)" class="icon">
            <img src="./../../../../../assets/icon/down.png" />
          </span>
          <span v-if="rowData.status == 1" @click="upDownTicket(0)" class="icon">
            <img src="./../../../../../assets/icon/put.png" />
          </span>
          <span @click="up" class="icon" style="margin: 0 10px;">
            <img src="./../../../../../assets/icon/move_up.png" />
          </span>
          <span @click="down" class="icon">
            <img src="./../../../../../assets/icon/move_down.png" />
          </span>
          <span style="margin:0 10px;" @click="settingHandler" class="icon">
            <img src="./../../../../../assets/icon/setting.png" />
          </span>
          <span @click="deleteHandler" class="icon">
            <img src="./../../../../../assets/icon/del.png" />
          </span>
        </li>
      </ul>
      <!-- 内容扩展区域 -->
      <div class="ticket-extend" v-if="isShowExtend">
        <div class="ticket-view">
          <div class="row">
            <div class="label">票品简介:</div>
            <div class="input">
              <el-form-item>
                <el-input v-model="rowData.description" placeholder="请输入票品简介" type="textarea" style="width: 400px; resize:none;"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="row">
            <div class="label">信息登记:</div>
            <div class="input row">
              <div class="">
                <el-form-item>
                  <el-switch v-model="rowData.isRealName" active-color="#409EFF" :active-value="1" :inactive-value="0" inactive-color="#ddd" @change="HanleIsRealName"></el-switch>
                </el-form-item>
              </div>
              <div class="row">
                <div class="label t" v-if="rowData.typeId == 16">开启后，购买该票需要填写对应数量的购票人信息(姓名、手机号码、性别、出生日期、所在地区)</div>
                <div class="label t" v-if="rowData.typeId == 17">开启后，购买该票需要填写对应数量的购票人信息(姓名、手机号码、性别、出生日期、所在地区)</div>
                <div class="label t" v-if="rowData.typeId == 18">开启后，购买该票需要填写对应数量的购票人信息 (参赛昵称、战队名称、手机号码、性别、出生日期、所在地区)</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="label">购买限制:</div>
            <div class="input row">
              <div class="">
                <el-form-item>
                  <el-switch v-model="rowData.isLimit" active-color="#409EFF" :active-value="1" :inactive-value="0" inactive-color="#ddd"></el-switch>
                </el-form-item>
              </div>
              <div class="row" v-if="rowData.isLimit">
                <div class="label" style="width: 150px;">每人最多可购买:</div>
                <div class="input">
                  <el-form-item prop="limitCount">
                    <el-input-number v-model="rowData.limitCount" :min="1" :max="10000" label="请输入限购数量"></el-input-number>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { priceReg } from '@/constant';
export default {
  props: {
    rowData: {
      type: Object,
      default: () => { },
    },
    index: {
      type: Number,
      default: 0,
    },
    ticketTypeList: {
      type: Array,
      default: () => [],
    }
  },
  data () {
    // 校验数量
    const checkCountNumber = (rule, value, callback) => {
      if (!value && value != 0) {
        return callback(new Error('请输入票品数量'))
      }
      setTimeout(() => {
        if (/^\d+$/.test(value)) {
          callback()
        } else {
          return callback(new Error('票品库存只能是正整数'))
        }
      }, 100)
    }
    // 校验价格
    const cheeckPrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入价格'));
      }
      setTimeout(() => {
        if (priceReg.test(value)) {
          callback();
        } else {
          return callback(new Error('票品价格格式错误'));
        }
      })
    }
    return {
      isShowExtend: true,
      isEdit: false,
      watchRowData: {},
      rules: {
        name: [
          { required: true, message: '请输入票品名称', trigger: 'blur' },
        ],
        typeId: [
          { required: true, message: '请选择票品名称', trigger: 'blur' },
        ],
        price: [
          { required: true, message: '请输入单价', trigger: 'blur' },
          { validator: cheeckPrice, trigger: 'blur' }
        ],
        count: [
          { required: true, message: '请输入票品数量', trigger: 'blur' },
          { validator: checkCountNumber, trigger: 'blur' }
        ],
        limitCount: [
          { required: true, message: '请输入限购数量', trigger: 'blur' },
        ]
      },
    }
  },
  methods: {
    // 上下架操作
    upDownTicket (val) {
      this.rowData.status = val;
      this.$emit('changeIsRealName')
      // this.form = Object.assign(this.form, { status: val });
    },
    // 手动排序
    up () {
      this.$emit('sortItem', { type: 'up', index: this.index });
    },
    down () {
      this.$emit('sortItem', { type: 'down', index: this.index });
    },
    settingHandler () {
      this.isShowExtend = !this.isShowExtend;
    },
    deleteHandler () {
      this.$emit('deleteItem', this.index);
    },
    getFormData () {
      return new Promise((resolve) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            resolve({
              data: {
                ...this.rowData,
                isLimit: this.rowData.isLimit ? 1 : 0,
                limitCount: this.rowData.isLimit ? this.rowData.limitCount : null,
              },
              isValid: true,
            });
          } else {
            // this.$message.error('请查看票务必填字段');
            resolve({ data: {}, isValid: false });
          }
        });
      })
    },
    changeType(e) {
      console.log(e)
      let list = JSON.parse(JSON.stringify(this.ticketTypeList))
      if (list.find(v => v.id === e).label == '选手票') {
        this.rowData.isRealName = 1;
        this.HanleIsRealName()
      }
    },
    HanleIsRealName() {
      this.$emit('changeIsRealName')
    }
  },
  computed: {
    disabledInput () {
      if (this.rowData && this.rowData.id) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket-group {
  margin-bottom: 10px;
}
.ticket-body {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding: 5px 0;
  .ticket-td {
    flex: 1;
    list-style: none;
    text-align: center;
    margin: 0 10px;
    &:last-child {
      flex: 1.5;
    }
  }
  .setting {
    span {
      cursor: pointer;
    }
  }
}
.ticket-extend {
  margin: 20px 0;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding: 20px 0;
  .ticket-view {
    background: #f1f2f1;
    padding: 10px;
    border-radius: 5px;
    .row {
      display: flex;
      flex-direction: row;
      .label {
        width: 100px;
        text-align: left;
        margin-right: 10px;
      }
      .label.t{
        width: 700px;
      }
    }
  }
}
.icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  img {
    width: inherit;
    height: inherit;
    vertical-align: middle;
  }
}
</style>